import { Card, Skeleton } from "@heroui/react";
import React from "react";

const MeetingCardSkeleton = () => {
  return (
    <Card className="glass-surface">
      <Card.Header className="flex-row items-center justify-between">
        <Skeleton className="bg-glass h-3 w-24 rounded-full" />
        <Skeleton className="bg-glass h-3 w-10 rounded-full" />
      </Card.Header>

      <Card.Content>
        <div className="flex gap-2 items-center">
          <div className="w-[3px] bg-glass min-h-6 rounded-full" />
          <Skeleton className="bg-glass h-5 w-2/5 rounded-md" />
        </div>

        <div className="flex -space-x-1">
          {[0, 1, 2].map((i) => (
            <Skeleton
              key={i}
              className="bg-glass h-6 w-6 rounded-full border border-glass-border"
            />
          ))}
        </div>

        <div className="flex flex-col gap-1">
          <Skeleton className="bg-glass h-3 w-3/5 rounded-full" />
          <Skeleton className="bg-glass h-3 w-2/5 rounded-full" />
        </div>
      </Card.Content>
    </Card>
  );
};

export default MeetingCardSkeleton;